import React, { Component } from 'react'
import './style.css'
import StickyNote from './StickyNote'
import Alert from '../etc/Alert'
import Reader from '../../controller/Reader' 
import Creater from '../../controller/Creater'

export default class Sticky extends Component {

    state = { 
        memos: [],
        isAlert: false
    }

    componentDidMount() {

        this.getFx()

    }
    

    getFx = () => {

        const condition = {
            url : '/api/sticky'
        }

        Reader(condition, res => {
            if(res.data !== null) {
            this.setState({ memos : res.data })
            }
        })
    
    }

    
    addFx = () => {

        if(!this.props.isLogin) {
            this.setState({ isAlert : true })
            return
        }
            
        const posX1 = window.innerWidth * 0.4
        const posY1 = window.innerHeight * 0.4
        const posX2 = window.innerWidth * 0.6
        const posY2 = window.innerHeight * 0.6

        let randId = Math.floor(Math.random() * 10000) + 1
        let randPosX = Math.floor(Math.random() * (posX2 - posX1 + 1) ) + posX1
        let randPosY = Math.floor(Math.random() * (posY2 - posY1 + 1) ) + posY1
        let newMemo = {'_id': randId, 'txt': '', 'posX':randPosX, 'posY':randPosY}

        this.setState({
            memos: this.state.memos.concat(newMemo)
        })

        let condition = {
            url : '/api/sticky/add',
            data : newMemo
        }

        Creater(condition, res => {

            if(res.data === 'blocked' || !res.data) {
                this.setState({ isAlert : true})
                return

            }

        })          
            
    }


    closeFx = () => {
        this.setState({
            isAlert : false
        })
    }


    render() {

        const Banner = {
			backgroundImage : 'url("/sticky.jpg")',
            height : '100vh',
            overflowY: 'hidden'
        }
  
        let noteList = this.state.memos.map( memo => {

            return (
                <React.Fragment>
                    <StickyNote idName={memo._id} txt={memo.txt} posX={memo.posX} posY={memo.posY} isLogin={this.props.isLogin} isMobile={this.props.isMobile}/>
                </React.Fragment>
            )
            
        })


        return (

            <div className='WideContainer' style={Banner}>

                {this.state.isAlert ? <Alert alert = 'Access Denied' closeMe = {this.closeFx} /> : null}                
                
                { noteList }

                <div className='StickyAdd'>
                    <i className='material-icons' onClick={this.addFx}>add_circle</i>
                </div>


                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/sticky/index.js